import React, { Component } from 'react';
import events from '../../../services/events';
import ElementFolderListTemplate from './ElementFolderListTemplate';
import { connect } from 'react-redux';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import { Icons } from '../../../utilities';
import * as Constants from '../../../utilities/constants/Constants';
import SearchBar from '../../../components/SearchBar/SearchBar';
import LoadMoreContentsTemplate from '../../../components/LoadingTemplate/LoadMoreContentsTemplate';
import '../SideBarContainer.scss';
import { string } from '../../../localization';
import { Popover } from 'reactstrap';
import DesignDescription from '../../../components/InfoPanels/DesignDescription/DesignDescription';
import {
  currencyConversion,
  isPremiumTheme
} from '../../../utilities/HelperFunctions/HelperFunctions';
import PointedSeparator from '../../../UI/PointedSeparater/PointedSeparator';

export const currencyPlacing = placement => {
  if (placement === Constants.BEFORE_PRICE_KEY) {
    return 'price-tag flex-row-reverse';
  }
  return 'price-tag';
};

export const getFolderListElementStyle = (activeSidebarTab, theme) => {
  let style = null;

  if (activeSidebarTab === Constants.PHOTO_TAB_KEY) {
    style = 'border-grey';
  } else if (
    activeSidebarTab === Constants.ELEMENT_TAB_KEY &&
    theme === Constants.THEME.STICKERS
  ) {
    style = 'stickers-bacground';
  } else if (activeSidebarTab === Constants.ELEMENT_TAB_KEY) {
    style = 'bg-white';
  }

  return ['folder-list-element', style].join(' ');
};

class ElementListTemplate extends Component {
  state = {
    activeItem: null,
    viewPriceIsVisible: false
  };

  componentDidMount() {
    this.scrollView.addEventListener('scroll', e => this.trackScrolling(e));
  }

  componentWillUnmount() {
    const { dispatchers } = this.props;
    const { activeItem } = this.state;
    dispatchers.sideBarActions.elementListTemplateUnMount();
    this.scrollView.removeEventListener('scroll', e => this.trackScrolling(e));
    this.resetItem(activeItem);
  }

  trackScrolling = e => {
    const { moreImagesLoadingIndicator, maximumLimit } = this.props;

    if (
      this.scrollView.scrollTop + this.scrollView.clientHeight >=
      this.scrollView.scrollHeight
    ) {
      if (!moreImagesLoadingIndicator && !maximumLimit) {
        e.preventDefault();
        e.stopPropagation();
        this.loadMoreItems();
      } else if (!moreImagesLoadingIndicator && maximumLimit) {
        e.preventDefault();
        e.stopPropagation();
        this.scrollView.scrollTo(0, this.scrollView.scrollTop - 2);
      }
    }
  };

  loadMoreItems = () => {
    const {
      searchTags,
      folderListElements,
      unsplashPlaceholder,
      shouldLoadMoreContents,
      dispatchers,
      gettyImageBackgroundPlaceholder,
      gettyImagePhotosPlaceholder,
      gettyImageObjectsPlaceholder,
      iStockBackgroundPlaceholder,
      iStockPhotosPlaceholder,
      iStockObjectsPlaceholder
    } = this.props;

    const currentPage = searchTags.updatedPage + 1;
    const theme = folderListElements;

    if (theme.elements === unsplashPlaceholder && !shouldLoadMoreContents) {
      dispatchers.sideBarActions.setShowLoading(true);
      dispatchers.sideBarActions.setSearchTags(null, null, currentPage);
    }
    if (
      (theme.elements === gettyImageBackgroundPlaceholder ||
        gettyImagePhotosPlaceholder ||
        gettyImageObjectsPlaceholder) &&
      !shouldLoadMoreContents
    ) {
      dispatchers.sideBarActions.setShowLoading(true);
      dispatchers.sideBarActions.setSearchTags(null, null, currentPage);
    }
    if (
      (theme.elements === iStockBackgroundPlaceholder ||
        iStockPhotosPlaceholder ||
        iStockObjectsPlaceholder) &&
      !shouldLoadMoreContents
    ) {
      dispatchers.sideBarActions.setShowLoading(true);
      dispatchers.sideBarActions.setSearchTags(null, null, currentPage);
    }

    if (shouldLoadMoreContents) {
      dispatchers.sideBarActions.setShowLoading(true);
      dispatchers.sideBarActions.setSearchTags(
        searchTags.updatedPatternColor,
        searchTags.updatedText,
        currentPage
      );
    } else if (
      theme.name === Constants.DREAMSTIME ||
      theme.name === Constants.ADOBE_STOCK ||
      theme.name === Constants.HP_MOSAIC
    ) {
      dispatchers.sideBarActions.setShowLoading(true);
      dispatchers.sideBarActions.setSearchTags(null, null, currentPage);
    }
  };

  localAddToCanvas = item => {
    const { addToCanvas } = this.props;
    addToCanvas(item);
  };

  toggleInfoPanel = item => {
    const { activeItem } = this.state;
    if (activeItem !== null) {
      if (this.getUniqueId(item) !== this.getUniqueId(activeItem)) {
        item.showPriceTag = !item.showPriceTag;
      }
    } else {
      item.showPriceTag = true;
    }

    item.popoverOpen = !item.popoverOpen;
    this.setState({ activeItem: item });
  };

  resetItem = item => {
    const { activeItem } = this.state;

    if (activeItem !== null) {
      item.showPriceTag = false;
      item.popoverOpen = false;
    }
  };

  viewPriceVisiblityHandler = () => {
    const { viewPriceIsVisible } = this.state;
    this.setState({ viewPriceIsVisible: !viewPriceIsVisible });
  };

  canAddSearchIcon = () => {
    const { searchBarIsVisible, folderListElements } = this.props;
    if (
      !searchBarIsVisible &&
      isPremiumTheme(folderListElements) &&
      folderListElements.name !== Constants.HP_MOSAIC
    ) {
      return true;
    }
    return false;
  };

  canAddRandomizeButton = () => {
    const { folderListElements } = this.props;
    if (
      isPremiumTheme(folderListElements) &&
      folderListElements.name === Constants.HP_MOSAIC
    ) {
      return true;
    }
    return false;
  };

  shouldShowPriceTag = item =>
    Object.prototype.hasOwnProperty.call(item, 'showPriceTag') &&
    item.showPriceTag &&
    item.imageSource !== Constants.UNSPLASH_IMAGE_SOURCE &&
    item.type !== Constants.SCENE_KEY &&
    item.imageSource !== Constants.ADOBE_STOCK_IMAGE_SOURCE &&
    item.imageSource !== Constants.HP_MOSAIC_IMAGE_SOURCE;

  shouldShowPlaceableName = item => {
    const { showPlaceablesName } = this.props;
    return (
      showPlaceablesName &&
      item.imageSource !== Constants.PATTERN_DESIGN_IMAGE_SOURCE &&
      item.imageSource !== Constants.DREAMSTIME_IMAGE_SOURCE &&
      item.imageSource !== Constants.UNSPLASH_IMAGE_SOURCE &&
      item.imageSource !== Constants.VECTEEZY_IMAGE_SOURCE &&
      item.imageSource !== Constants.ADOBE_STOCK_IMAGE_SOURCE &&
      item.imageSource !== Constants.GETTY_IMAGE_SOURCE &&
      item.imageSource !== Constants.I_STOCK_IMAGE_SOURCE &&
      item.imageSource !== Constants.HP_MOSAIC_IMAGE_SOURCE
    );
  };

  setElememtBackgroundSize = theme => {
    const { activeTab } = this.props;
    if (activeTab === Constants.BACKGROUND_TAB_KEY) {
      return 'cover';
    }
    if (theme === 'Lines') return '400%';
    return 'contain';
  };

  getUniqueId = item => {
    if (item.id) {
      return item.id;
    }
    return item.mediaId;
  };

  render() {
    const {
      activeTab,
      folderListElements,
      searchBarIsVisible,
      searchedContents,
      searchMode,
      language,
      storeData,
      moreImagesLoadingIndicator,
      dispatchers
    } = this.props;
    const { activeItem } = this.state;

    let filterOptions = null;
    if (this.canAddSearchIcon()) {
      filterOptions = (
        <div
          role='button'
          style={{ outline: 0 }}
          tabIndex='0'
          onKeyPress={() => {}}
          onClick={() => {
            dispatchers.sideBarActions.searchBarHandler();
          }}
        >
          <img src={Icons.search} alt='search' style={{ cursor: 'pointer' }} />
        </div>
      );
    } else if (this.canAddRandomizeButton()) {
      filterOptions = (
        <div>
          <button
            type='button'
            className='randomize-button'
            onClick={() => {
              dispatchers.sideBarActions.handleHPMosaicCategory(
                folderListElements
              );
            }}
          >
            {string.RANDOMIZE_KEY}
          </button>
        </div>
      );
    }

    let infoVisibility = 'hidden';
    if (sideBarActions.isInfoButtonReq(folderListElements)) {
      infoVisibility = 'visible';
    }
    let contents = [];
    if (searchMode) {
      contents = searchedContents;
    } else {
      contents = folderListElements.elements;
    }
    const styleClass = moreImagesLoadingIndicator
      ? 'theme-wrapper theme-wrapper-scroll-bar more-load-indicator-height'
      : 'theme-wrapper theme-wrapper-scroll-bar normal-height';

    contents.map(item => {
      if (
        activeItem !== null &&
        this.getUniqueId(item) !== this.getUniqueId(activeItem)
      ) {
        item.popoverOpen = false;
        item.showPriceTag = false;
      }
    });
    return (
      <div className='d-flex flex-column h-100 text-left'>
        <div className='folder-heading'>
          <div className='d-flex justify-content-between'>
            <button
              type='button'
              className='back-box'
              style={{
                border: 'none',
                background: 'none',
                outline: 'none',
                color: 'white'
              }}
              onClick={() => {
                dispatchers.sideBarActions.getParentFromFolder(
                  folderListElements.parentId,
                  folderListElements.id
                );
              }}
            >
              <img
                alt='back-icon'
                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAXCAYAAAGnofUXAAAABGdBTUEAALGPC/xhBQAAAItJREFUOBHdUEEKgDAMm/5kF7/hzwT/6x9mW8woaxx6UFBB65I0aZdS/yml5CSfWWVj0IKpknMFGHPUA+3tRDgDmwZnq2pWDcFcB9GhlXZ5ARMNreAQZYYbJjFLIAXcXgElJF61T6aTQPAcGa8Emb5K/qwzaPU4/f+iWBeRuVd5J7pUD7y1cGv0k+YdnvjcLNGBaDEAAAAASUVORK5CYII='
              />
              <span>{string.BACK_KEY}</span>
            </button>

            {/* Search Bar */}

            {filterOptions}
          </div>

          <div
            className={searchBarIsVisible ? 'search-fadeIn' : 'search-fadeOut'}
          >
            <SearchBar name={folderListElements.name} />
          </div>

          <div className='folder-theme-label d-flex justify-content-between'>
            <div>
              {Object.prototype.hasOwnProperty.call(
                folderListElements,
                'locNames'
              ) && folderListElements.locNames
                ? folderListElements.locNames[language]
                : folderListElements.name}
            </div>
            {sideBarActions.showPremiumTag(folderListElements) ? (
              <img
                src={Icons.premiumBadge}
                alt='Premium'
                className='premium-heading-tag'
              />
            ) : null}
          </div>
          <PointedSeparator />
        </div>

        <div className='flex-grow-1 content-box'>
          <div
            className={styleClass}
            ref={ref => {
              this.scrollView = ref;
            }}
          >
            {contents.map(item => (
              <div
                className='image-wraper'
                style={{ marginBottom: ' -7px' }}
                key={this.getUniqueId(item)}
              >
                <div
                  role='button'
                  tabIndex='0'
                  id={activeTab + item.imageSource + this.getUniqueId(item)}
                  className={getFolderListElementStyle(
                    activeTab,
                    folderListElements.name
                  )}
                  style={{
                    outline: 'none',
                    backgroundImage:
                      activeTab === Constants.BACKGROUND_TAB_KEY
                        ? `url(${item.thumbnailPath})`
                        : null,
                    backgroundSize: this.setElememtBackgroundSize(
                      folderListElements.name
                    )
                  }}
                  onKeyPress={() => {}}
                  onClick={() => {
                    dispatchers.fabricCanvasActions.addToCanvas(item);
                  }}
                  {...(activeTab === Constants.ELEMENT_TAB_KEY ||
                  activeTab === Constants.PHOTO_TAB_KEY
                    ? {
                        draggable: 'true',
                        onDragStart: e => {
                          events.onDragStart(
                            e,
                            item,
                            dispatchers.fabricCanvasActions.addToCanvas
                          );
                        },
                        onDragEnd: e => {
                          events.onDragEnd(e, item);
                        }
                      }
                    : {})}
                >
                  {activeTab !== Constants.BACKGROUND_TAB_KEY ? (
                    <div
                      className='inner-elemet'
                      style={{
                        backgroundImage: `url(${item.thumbnailPath})`,
                        backgroundSize: this.setElememtBackgroundSize(
                          folderListElements.name
                        )
                      }}
                    />
                  ) : null}
                  <div
                    className={`hover-layer-folder ${
                      activeTab !== Constants.BACKGROUND_TAB_KEY
                        ? 'element-border'
                        : null
                    }`}
                  />
                  <div
                    role='button'
                    tabIndex='0'
                    style={{
                      visibility:
                        Object.prototype.hasOwnProperty.call(
                          item,
                          'showInfo'
                        ) && item.showInfo
                          ? 'visible'
                          : infoVisibility
                    }}
                    className='info-icon'
                    onKeyPress={() => {}}
                    onClick={e => {
                      if (e.stopPropagation) e.stopPropagation();
                      dispatchers.sideBarActions.patternInfoClicked(item);
                      this.toggleInfoPanel(item);
                      dispatchers.sideBarActions.patternDesignCost(item);
                    }}
                  >
                    <Popover
                      placement='bottom'
                      isOpen={item.popoverOpen}
                      target={
                        activeTab + item.imageSource + this.getUniqueId(item)
                      }
                    >
                      <DesignDescription
                        data={item}
                        onClose={() => this.toggleInfoPanel(item)}
                      />
                    </Popover>
                  </div>
                  {this.shouldShowPriceTag(item) ? (
                    <div
                      className={currencyPlacing(storeData.placeMsrpCurrency)}
                    >
                      <div>
                        {item.costValue
                          ? currencyConversion(
                              item,
                              storeData.conversionUnitEur,
                              storeData.conversionUnitUsd
                            ).toFixed(2)
                          : null}
                      </div>

                      <div>{storeData.msrpCurrency}</div>
                    </div>
                  ) : null}
                </div>
                {this.shouldShowPlaceableName(item) ? (
                  <div className='bg-obj-name'>
                    {item.name
                      ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
                      : null}
                  </div>
                ) : null}
              </div>
            ))}{' '}
            {!searchMode &&
            Object.prototype.hasOwnProperty.call(
              folderListElements,
              'folders'
            ) &&
            folderListElements.folders.length > 0
              ? folderListElements.folders.map(folder => (
                  <ElementFolderListTemplate key={folder.id} data={folder} />
                ))
              : ''}
          </div>
        </div>
        {moreImagesLoadingIndicator ? <LoadMoreContentsTemplate /> : null}
        {/* {viewPriceIsVisible ? (
          <ViewPrice
            title={activeItem.title}
            onClose={() => this.viewPriceVisiblityHandler()}
            imageURL={activeItem.imagePath}
          />
        ) : null} */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    folderListElements: state.sideBar.folderListElements,
    searchBarIsVisible: state.sideBar.searchBarIsVisible,
    language: state.home.language,
    searchMode: state.sideBar.searchMode,
    searchedContents: state.sideBar.searchedContents,
    shouldLoadMoreContents: state.sideBar.shouldLoadMoreContents,
    searchTags: state.sideBar.searchTags,
    showPlaceablesName: state.modal.storeData.showPlaceablesName,
    unsplashPlaceholder: state.modal.unsplashPlaceholder,
    vecteezyPlaceholder: state.modal.vecteezyPlaceholder,
    gettyImageBackgroundPlaceholder:
      state.modal.gettyImageBackgroundPlaceholder,
    gettyImagePhotosPlaceholder: state.modal.gettyImagePhotosPlaceholder,
    gettyImageObjectsPlaceholder: state.modal.gettyImageObjectsPlaceholder,
    iStockBackgroundPlaceholder: state.modal.iStockBackgroundPlaceholder,
    iStockPhotosPlaceholder: state.modal.iStockPhotosPlaceholder,
    iStockObjectsPlaceholder: state.modal.iStockObjectsPlaceholder,
    moreImagesLoadingIndicator: state.sideBar.showLoading,
    maximumLimit: state.sideBar.isMaximumLimit,
    triggerRedraw: state.sideBar.triggerRedraw,
    storeData: state.modal.storeData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ElementListTemplate);
